import {useState} from 'react'
import {MultiSelect, Option} from 'react-multi-select-component'
// import '../../../../../../style/multiSelectSucess.css'

const ListSearchStatus = ({setSubscriptionStatusSearch, selectsStatus, setSelectsStatus}) => {
  const initialSelectValue = [
    {value: '1', label: 'Pendente'},
    {value: '2', label: 'Pago'},
    {value: '3', label: 'Cancelado'},
  ]
  const [saleStatus, setStatus] = useState<Option[]>(initialSelectValue)

  return (
    <>
      <div className='mb-5'>
        <label className='form-label fs-6 fw-bold'>Pesquisar por Status:</label>
        <MultiSelect
          className='form-control rmscStyle'
          data-kt-user-table-filter='status'
          options={saleStatus}
          value={selectsStatus}
          onChange={(option) => {
            const valores = option.map((item) => item.value)
            setSubscriptionStatusSearch(valores)
            setSelectsStatus(option)
          }}
          labelledBy={''}
          overrideStrings={{
            selectSomeItems: 'Selecione o(os) Status',
            search: 'Procurar',
            selectAll: 'Selecionar todos',
            allItemsAreSelected: 'Todos statuses selecionados',
          }}
        />
      </div>
    </>
  )
}

export {ListSearchStatus}
